// Template264: Pekín - Plan de viaje (MenuPekin.jsx)
// Cabecera roja, días y extras en columna: mismo estilo móvil y escritorio (imagen 45px izquierda + caja blanca).

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template264 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
	onNavigateToPage,
	pages = [],
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const pageData = page?.data || {};
	const diasRaw = Array.isArray(pageData.dias) ? pageData.dias : [];
	const extrasRaw = Array.isArray(pageData.extras) ? pageData.extras : [];

	const diasTemplateMapping =
		Array.isArray(pageData.diasTemplateMapping) &&
		pageData.diasTemplateMapping.length > 0
			? pageData.diasTemplateMapping
			: [246, 246, 246];
	const extrasTemplateMapping =
		Array.isArray(pageData.extrasTemplateMapping) &&
		pageData.extrasTemplateMapping.length > 0
			? pageData.extrasTemplateMapping
			: [259, 261, 262, 262, 262, 262];

	const findPageByTemplateId = (templateId, index = 0) => {
		const matches = pages.filter(
			(p) => p.templateId === templateId || p.data?.templateId === templateId,
		);
		return matches[index] || matches[0] || null;
	};
	const getPageId = (p) => p?.id ?? p?.data?.id;

	const dias = diasRaw.map((dia, index) => {
		const templateId = diasTemplateMapping[index];
		const occurrence =
			templateId == null
				? 0
				: diasTemplateMapping.slice(0, index).filter((t) => t === templateId)
						.length;
		const targetPage = templateId
			? findPageByTemplateId(templateId, occurrence)
			: null;
		return {
			...dia,
			pageId: dia.pageId || (targetPage ? getPageId(targetPage) : null),
		};
	});

	const extras = extrasRaw
		.map((extra, index) => {
			// Ocultar solo el enlace de donación "Kofi", no la sección "Dinero y pagos" (que puede usar icono kofi)
			if (extra.titulo === "Kofi") return null;
			const templateId = extrasTemplateMapping[index] ?? null;
			const occurrence =
				templateId == null
					? 0
					: extrasTemplateMapping
							.slice(0, index)
							.filter((t) => t === templateId).length;
			const targetPage = templateId
				? findPageByTemplateId(templateId, occurrence)
				: null;
			return {
				...extra,
				pageId: extra.pageId || (targetPage ? getPageId(targetPage) : null),
			};
		})
		.filter(Boolean);

	const actualHeaderColor = headerBackgroundColor || "#8c1d18";
	const headerText = page?.texts?.[0]?.content ?? "Plan de viaje";

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};
	const logoImage = getCanvasImageUrl("logo") || "/images/logo.png";

	const handleNavigate = (pageId) => {
		if (onNavigateToPage && pageId) onNavigateToPage(pageId);
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "100%",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				position: "relative",
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				<Box
					component="img"
					src={logoImage}
					alt="logo"
					sx={{
						width: isSmallScreen ? 66 : 80,
						position: "absolute",
						right: 2,
						top: 18,
						zIndex: 999999,
					}}
				/>
			</Box>

			<Box data-block-id="text-1" sx={{ padding: isSmallScreen ? "10px 10px" : "20px 16px" }}>
				{/* DÍAS - columna, mismo estilo móvil y escritorio */}
				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: "18px",
						flexWrap: "nowrap",
					}}
				>
					{dias.map((dia, index) => (
						<Box
							key={index}
							onClick={() => dia.pageId && handleNavigate(dia.pageId)}
							sx={{
								borderRadius: "12px",
								padding: 0,
								display: "flex",
								alignItems: "center",
								gap: "10px",
								position: "relative",
								minHeight: 30,

								cursor: dia.pageId ? "pointer" : "default",
								transition: "transform 0.3s ease",
								marginLeft: "20px",
								"&:hover": dia.pageId
									? {
											transform: "translateY(-5px)",
											"& .dia-box": {
												boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
											},
										}
									: {},
							}}
						>
							{dia.image && (
								<Box
									component="img"
									src={dia.image}
									alt=""
									sx={{
										width: 45,
										zIndex: 100,
										position: "absolute",
										left: -20,
									}}
								/>
							)}
							<Box
								className="dia-box"
								sx={{
									backgroundColor: "#fff",
									borderRadius: "12px",
									padding: "18px 16px",
									display: "flex",
									alignItems: "center",
									gap: "10px",
									position: "relative",
									minHeight: 30,
									width: "100%",
									marginLeft: 0,
									textAlign: "left",
									flex: 1,
									transition: "box-shadow 0.3s ease",
									paddingLeft: "16px",
								}}
							>
								<Box
									sx={{
										fontSize: "13px",
										fontWeight: 600,
										color: "#333",
										marginLeft: "20px",
										whiteSpace: "pre-line",
									}}
								>
									Día {index + 1}:{" "}
									{isSmallScreen && dia.tituloMovil
										? String(dia.tituloMovil).replace(/\\n/g, "\n")
										: dia.titulo}
								</Box>
							</Box>
						</Box>
					))}
				</Box>

				<Box
					component="h3"
					sx={{
						fontSize: 12,
						fontWeight: 700,
						margin: 0,
						textTransform: "uppercase",
						marginTop: "16px",
						marginBottom: "12px",
						color: "#333",
					}}
				>
					Información útil
				</Box>

				{/* EXTRAS - mismo diseño que días, mismo estilo en móvil y escritorio */}
				<Box
					data-block-id="text-3"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: "18px",
						flexWrap: "nowrap",
						paddingBottom: "2px",
					}}
				>
					{extras.map((extra, index) => (
						<Box
							key={index}
							onClick={() => extra.pageId && handleNavigate(extra.pageId)}
							sx={{
								borderRadius: "12px",
								padding: 0,
								display: "flex",
								alignItems: "center",
								gap: "10px",
								position: "relative",
								minHeight: 30,
								cursor: extra.pageId ? "pointer" : "default",
								transition: "transform 0.3s ease",
								marginLeft: "20px",
								"&:hover": extra.pageId
									? {
											transform: "translateY(-5px)",
											"& .extra-box": {
												boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
											},
										}
									: {},
							}}
						>
							{extra.image && (
								<Box
									component="img"
									src={extra.image}
									alt=""
									sx={{
										width: 45,
										zIndex: 100,
										position: "absolute",
										left: -20,
									}}
								/>
							)}
							<Box
								className="extra-box"
								sx={{
									backgroundColor: "#fff",
									borderRadius: "12px",
									padding: "18px 16px",
									display: "flex",
									alignItems: "center",
									gap: "10px",
									position: "relative",
									minHeight: 30,
									width: "100%",
									marginLeft: 0,
									textAlign: "left",
									flex: 1,
									transition: "box-shadow 0.3s ease",
									paddingLeft: "16px",
								}}
							>
								<Box
									sx={{
										fontSize: "13px",
										fontWeight: 600,
										color: "#333",
										marginLeft: "20px",
										whiteSpace: "pre-line",
									}}
								>
									{isSmallScreen && extra.tituloMovil
										? String(extra.tituloMovil).replace(/\\n/g, "\n")
										: extra.titulo}
								</Box>
							</Box>
						</Box>
					))}
				</Box>
			</Box>
		</Box>
	);
};

Template264.thumbnail = "/images/template-1.png";
export default Template264;
